const customTypes = ['text', 'textarea', 'tagger', 'multiselect', 'checkbox', 'integer', 'decimal', 'date', 'regexp']
const systemTypes = ['subject', 'description', 'priority', 'tickettype']
const trailingTypes = ['subject', 'description']
// [APAC] Request Type field: selecting "Report an issue" hides Subject/Description,
// which are otherwise always shown, since the structured fields it reveals cover that detail.
const reportIssueFieldId = '53351930495252'
const reportIssueValue = 'apac_request_report_issue'

export function ticketFields (fields) {
  if (!Array.isArray(fields)) throw new Error('Invalid ticket fields response')
  // Subject and Description are explicitly shown even when portal editing is disabled.
  const visible = fields.filter(field => field.active && (trailingTypes.includes(field.type) || (field.visible_in_portal && field.editable_in_portal)))
  if (visible.some(field => !customTypes.concat(systemTypes).includes(field.type))) {
    throw new Error('Unsupported ticket field type')
  }
  return visible.filter(field => !trailingTypes.includes(field.type))
    .concat(visible.filter(field => trailingTypes.includes(field.type)))
}

export function requiredTicketField (field) {
  if (typeof field.conditionRequired === 'boolean') return field.conditionRequired
  return !!field.required_in_portal
}

export function visibleTicketFields (fields, conditions, values) {
  const fieldIds = new Set(fields.map(field => String(field.id)))
  const conditionalIds = new Set()
  conditions.forEach(condition => {
    condition.child_fields.forEach(child => {
      const field = fields.find(field => String(field.id) === String(child.id))
      if (!field || !trailingTypes.includes(field.type)) conditionalIds.add(String(child.id))
    })
  })
  const visibleIds = new Set(fields.filter(field => !conditionalIds.has(String(field.id))).map(field => String(field.id)))
  const requiredIds = new Set()
  const childrenByParent = new Map()
  // Start from unconditional fields on every evaluation. Hidden parents (including
  // cycles without a visible ancestor) cannot activate descendants with stale values.
  let expanded = true
  while (expanded) {
    expanded = false
    conditions.forEach(condition => {
      if (!visibleIds.has(String(condition.parent_field_id))) return
      const value = values[condition.parent_field_id]
      const selected = Array.isArray(value) ? value : [value]
      if (!selected.some(option => option != null && String(option) === String(condition.value))) return
      const parentId = String(condition.parent_field_id)
      if (!childrenByParent.has(parentId)) childrenByParent.set(parentId, new Set())
      condition.child_fields.forEach(child => {
        const id = String(child.id)
        if (!fieldIds.has(id)) return
        childrenByParent.get(parentId).add(id)
        if (!visibleIds.has(id)) {
          visibleIds.add(id)
          expanded = true
        }
        if (child.is_required) requiredIds.add(id)
      })
    })
  }
  const ordered = []
  const rendered = new Set()
  // Keep roots and siblings in API field order, placing each active subtree
  // immediately after its parent. Shared children render once at the first match.
  function appendField (field) {
    const id = String(field.id)
    if (rendered.has(id)) return
    rendered.add(id)
    ordered.push(conditionalIds.has(id) ? { ...field, conditionRequired: requiredIds.has(id) } : field)
    const children = childrenByParent.get(id)
    if (children) fields.filter(child => children.has(String(child.id))).forEach(appendField)
  }
  fields.filter(field => !conditionalIds.has(String(field.id))).forEach(appendField)
  const parentValue = values[reportIssueFieldId]
  const selectedParent = Array.isArray(parentValue) ? parentValue : [parentValue]
  const hideTrailing = selectedParent.some(option => option != null && String(option) === reportIssueValue)
  return ordered.filter(field => !trailingTypes.includes(field.type))
    .concat(hideTrailing ? [] : fields.filter(field => trailingTypes.includes(field.type)))
}

export function ticketPayload (fields, values) {
  const payload = {
    customFields: [],
  }
  fields.forEach(field => {
    const value = values[field.id]
    if (value !== '' && value != null && (!Array.isArray(value) || value.length)) {
      payload.customFields.push({ id: field.id, value: Array.isArray(value) ? value : [String(value).trim()] })
    }
  })
  return payload
}
